import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import installElementPlus from './plugins/element'
import './styles/index.scss'
import './permission.js'
import i18n from './i18n'
import installFilter from './filters'
import installPrint from './directives'

import installIcon from './icons'

const app = createApp(App)
installElementPlus(app)
installIcon(app)
installFilter(app)
installPrint(app)
app.use(store).use(router).use(i18n).mount('#app')
